import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)); }, []);

  const furnitureGroups = [
    { label: "Branded Furniture", note: "Recognised furniture brands." },
    { label: "Wood Mart Vendor Collections", note: "Curated local vendors.", link: "/vendors" },
    { label: "Wood Mart Signature Collection", note: "Our own standardised designs.", link: "/wood-mart?type=signature" },
  ];

  return (
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-10">
      <h1 className="text-4xl font-extrabold text-midnight">Brands</h1>
      <p className="mt-1 text-muted-foreground">Recognised brands and curated collections across KRVMart.</p>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {brands.map((b, i) => (
          <Reveal key={b.name} delay={(i % 5) * 0.04}>
            <Link to={`/shop?brand=${encodeURIComponent(b.name)}`} data-testid={`brand-${b.name}`} className="group flex h-32 flex-col items-center justify-center gap-2 rounded-3xl border border-border bg-card transition-shadow hover:shadow-lg">
              <div className="grid h-12 w-12 place-items-center rounded-full bg-midnight text-white font-extrabold group-hover:bg-gold group-hover:text-midnight transition-colors">{b.name[0]}</div>
              <span className="text-sm font-bold text-midnight text-center px-2">{b.name}</span>
              <span className="text-[10px] text-muted-foreground">{b.categories.join(", ")}</span>
            </Link>
          </Reveal>
        ))}
      </div>

      <h2 className="mt-14 mb-4 text-2xl font-extrabold text-midnight">Furniture at KRVMart</h2>
      <div className="grid md:grid-cols-3 gap-5">
        {furnitureGroups.map((g) => (
          <div key={g.label} className="rounded-3xl border border-border p-6">
            <div className="mb-2 h-1 w-12 rounded-full bg-mart-wood" />
            <h3 className="font-extrabold text-midnight">{g.label}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{g.note}</p>
            {g.link && <Link to={g.link} className="mt-3 inline-block text-sm font-bold text-gold-dark">Explore →</Link>}
          </div>
        ))}
      </div>
    </div>
  );
}
